module.exports = __webpack_public_path__ + "img/ir.7bf140ab.svg";